import { render, staticRenderFns } from "./FooterLogoSvg.vue?vue&type=template&id=0fe1789e&scoped=true&"
import script from "./FooterLogoSvg.vue?vue&type=script&lang=js&"
export * from "./FooterLogoSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe1789e",
  null
  
)

export default component.exports